import { z } from 'zod';
import { IdSchema } from './encoding.js';
/**
 * Supplier master contracts (ERD §7.2, R1). Only the R1 attributes the model defines; vendor
 * scoring is Phase 2 and absent here. The Supplier ID (`code`) is generated from its number series
 * (FRD-CORE-035), so a create request carries none. Purchase requests, orders and receipts follow.
 */
export const SupplierSchema = z.object({
    id: IdSchema,
    code: z.string(),
    companyName: z.string(),
    contactName: z.string().nullable(),
    contactEmail: z.string().nullable(),
    contactPhone: z.string().nullable(),
    addressLine1: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string().nullable(),
    /** Sensitive (ERD §7.2): masked unless the caller holds the category. */
    trn: z.string().nullable(),
    bankAccountName: z.string().nullable(),
    bankAccountNumber: z.string().nullable(),
    bankName: z.string().nullable(),
    categoryCode: z.string().nullable(),
    status: z.string(),
    version: z.number().int(),
});
export const CreateSupplierRequestSchema = z.strictObject({
    companyName: z.string().min(1).max(200),
    contactName: z.string().max(200).optional(),
    contactEmail: z.email().max(254).optional(),
    contactPhone: z.string().max(50).optional(),
    addressLine1: z.string().max(200).optional(),
    city: z.string().max(100).optional(),
    country: z.string().max(100).optional(),
    trn: z.string().min(1).max(50).optional(),
    bankAccountName: z.string().max(200).optional(),
    bankAccountNumber: z.string().max(64).optional(),
    bankName: z.string().max(200).optional(),
    categoryCode: z.string().max(50).optional(),
});
export const UpdateSupplierRequestSchema = z.strictObject({
    companyName: z.string().min(1).max(200).optional(),
    contactName: z.string().max(200).nullable().optional(),
    contactEmail: z.email().max(254).nullable().optional(),
    contactPhone: z.string().max(50).nullable().optional(),
    addressLine1: z.string().max(200).nullable().optional(),
    city: z.string().max(100).nullable().optional(),
    country: z.string().max(100).nullable().optional(),
    trn: z.string().min(1).max(50).nullable().optional(),
    bankAccountName: z.string().max(200).nullable().optional(),
    bankAccountNumber: z.string().max(64).nullable().optional(),
    bankName: z.string().max(200).nullable().optional(),
    categoryCode: z.string().max(50).nullable().optional(),
    status: z.enum(['active', 'inactive']).optional(),
});
/** One value of the supplier category list (ERD §7.2); inactive values label history only. */
export const SupplierCategorySchema = z.object({
    valueCode: z.string(),
    label: z.string(),
    active: z.boolean(),
});
//# sourceMappingURL=procurement.js.map